// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"loadingStake_loadingWrapper__2LFdc","loadingTab":"loadingStake_loadingTab__3LTpC"};